<template>
  <select v-model="selected">
    <option></option>
    <option v-for="(name, code) of types" :value="code" :key="code">
      {{ name }}
    </option>
  </select>
</template>

<script lang="ts">
import _ from 'lodash'
import { scheduleType, ScheduleTypes } from '@/store/schedules/types';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SelectScheduleTypeInput extends Vue {
  @Prop() value?: scheduleType

  @Prop({ default: false }) isDownloadOthers?: boolean

  @Prop({ default: false }) isAddSchedule?: boolean

  private get selected(): scheduleType|undefined {
    return this.value
  }

  private set selected(type: scheduleType|undefined) {
    this.$emit('input', type)
  }

  private get types() {
    if (this.isDownloadOthers) {
      return _.omit(ScheduleTypes, ['lesson', 'subLesson'])
    }
    if (this.isAddSchedule) {
      return _.omit(ScheduleTypes, ['lesson', 'subLesson', 'absent'])
    }
    return ScheduleTypes
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
